@if (!tooltipOnly) {
  <span class="item-label" (mouseenter)="onMouseEnter()" (mouseleave)="onMouseLeave()">
    <img class="base-type-image" [src]="imgPrefix + '/img/gear/divination/divinationcard.webp'" loading="lazy" />
    {{ name }}
  </span>
}

@if (divinationCard && (tooltipOnly || pinned || (!hideTooltip && showTooltip))) {
  <div class="div-card" [class.relative]="tooltipOnly">
    <div class="dc-icon" [style.backgroundImage]="getBackgroundImage()"></div>
    <div class="dc-title">
      {{ divinationCard.name }}
      @if (pinned) {
        <span class="icon icon-pushpin icon-smaller"></span>
      }
    </div>
    <div class="dc-stats poe-scrollbar">
      <div class="dc-explicit" [innerHTML]="divinationCard.text"></div>
      <div class="dc-separator"></div>
      @if (showDropInfo && divinationCard.dropInfo) {
        @if (divinationCard.dropInfo.areas || divinationCard.dropInfo.monsters || divinationCard.dropInfo.dropsPerMap || divinationCard.dropInfo.minLevel || divinationCard.dropInfo.weight) {
          <div class="dc-explicit">
            @if (divinationCard.dropInfo.areas) {
              <div class="property-color">Areas:
                @for (area of divinationCard.dropInfo.areas; track area) {<span class="property-value-color property-list-item">{{ area }}</span>}
              </div>
            }
            @if (divinationCard.dropInfo.monsters) {
              <div class="property-color">Monsters:
                @for (monster of divinationCard.dropInfo.monsters; track monster) {<span class="property-value-color property-list-item">{{ monster }}</span>}
              </div>
            }
            @if (divinationCard.dropInfo.minLevel) {
              <div class="property-color">Min level: <span class="property-value-color">{{ divinationCard.dropInfo.minLevel }}</span></div>
            }
            @if (divinationCard.dropInfo.weight) {
              <div class="property-color">Weight: <span class="property-value-color">{{ divinationCard.dropInfo.weight }}</span></div>
            }
            @if (divinationCard.dropInfo.dropsPerMap) {
              <div class="property-color">Drops per map: <span class="property-value-color">{{ divinationCard.dropInfo.dropsPerMap }}</span></div>
            }
          </div>

          @if (divinationCard.dropInfo.text) {
            <div class="dc-separator"></div>
          }
        }
        @if (divinationCard.dropInfo.text) {
          <div class="dc-explicit property-color">
            {{ divinationCard.dropInfo.text }}
          </div>
        }
      } @else {
        <div class="dc-flavour-text" [innerHTML]="divinationCard.flavourText"></div>
      }
    </div>
    <div class="dc-stack-size">1/{{ divinationCard.stackSize }}</div>
    <div class="dc-price">
      <span app-value [baseType]="divinationCard.name" [rtl]="true" [hideExtraInfo]="true"></span>
    </div>
  </div>
}
